import { memo } from 'react';

import useExternalTokenListener from 'src/hooks/useExternalTokenListener';

const ExternalTokenListener = () => {
  useExternalTokenListener();

  return null;
};

export default memo(ExternalTokenListener);
